// CB Lemons Menu Manager - v1
import React from 'react';
import ReactDOM from 'react-dom/client';
import CBLemonsApp from './cblemons-app';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CBLemonsApp />
  </React.StrictMode>
);
